<div *ngIf="pagination && pagination.total_pages > 0" class="px-6 py-4 border-t border-gray-200 dark:border-gray-700 flex flex-col sm:flex-row items-center justify-between gap-4">
  <div class="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
    <span>Showing</span>
    <select
      [value]="pagination.per_page"
      (change)="changeItemsPerPage(+$any($event.target).value)"
      class="px-2 py-1 rounded border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500 transition-all hover:border-primary-500"
    >
      <option *ngFor="let option of itemsPerPageOptions" [value]="option" [selected]="option === pagination.per_page">{{ option }}</option>
    </select>
    <span>of {{ pagination.total_records }} items</span>
  </div>

  <div class="flex items-center gap-2">
    <button
      (click)="goToPage(pagination.current_page - 1)"
      [disabled]="!pagination.has_prev"
      class="px-3 py-2 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 transform hover:scale-105 active:scale-95 disabled:transform-none ripple"
    >
      Previous
    </button>

    <div class="flex items-center gap-1">
      <button
        *ngFor="let page of getPageNumbers()"
        (click)="goToPage(page)"
        [class.bg-primary-600]="page === pagination.current_page"
        [class.text-white]="page === pagination.current_page"
        [class.bg-white]="page !== pagination.current_page"
        [class.dark:bg-gray-700]="page !== pagination.current_page"
        [class.text-gray-700]="page !== pagination.current_page"
        [class.dark:text-gray-300]="page !== pagination.current_page"
        [class.border-primary-500]="page === pagination.current_page"
        class="px-3 py-2 text-sm rounded-lg border border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600 transition-all duration-200 transform hover:scale-110 active:scale-95 min-w-[40px] ripple"
      >
        {{ page }}
      </button>
    </div>

    <button
      (click)="goToPage(pagination.current_page + 1)"
      [disabled]="!pagination.has_next"
      class="px-3 py-2 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 transform hover:scale-105 active:scale-95 disabled:transform-none ripple"
    >
      Next
    </button>
  </div>
</div>
